<template>
  <v-card outlined>
    <v-card-title class="subtitle-1">
      {{ $t('communication_preferences') }}
    </v-card-title>

    <v-card-subtitle class="caption">
      {{ $t('communication_preferences_hint') }}
    </v-card-subtitle>

    <v-card-text>
      <v-skeleton-loader v-if="loading" type="list-item@3" />
      <template v-else>
        <!-- Gobierna a todas las demás: apagado, no sale ningún mensaje -->
        <v-switch
          class="mt-0"
          color="primary"
          name="whatsapp_enabled"
          :label="$t('allow_whatsapp_messages')"
          v-model="preference.whatsapp_enabled"
          @change="save()"
        />

        <v-divider class="mb-3" />

        <div class="caption font-weight-medium mb-1">
          {{ $t('operational_messages') }}
        </div>
        <v-switch
          v-for="option in operational"
          :key="`preference-${option}`"
          class="mt-0"
          color="primary"
          dense
          hide-details
          :name="option"
          :label="$t(option)"
          :disabled="!preference.whatsapp_enabled"
          v-model="preference[option]"
          @change="save()"
        />

        <v-divider class="my-3" />

        <div class="caption font-weight-medium mb-1">
          {{ $t('commercial_messages') }}
        </div>
        <v-switch
          class="mt-0"
          color="primary"
          dense
          hide-details
          name="marketing"
          :label="$t('marketing')"
          :disabled="!preference.whatsapp_enabled"
          v-model="preference.marketing"
          @change="save()"
        />
      </template>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'preferences-card',
  props: {
    customer: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      loading: false,
      saving: false,
      operational: [
        'order_updates',
        'design_notifications',
        'production_notifications',
        'delivery_notifications',
        'payment_reminders'
      ],
      preference: {
        pk: null,
        whatsapp_enabled: false,
        order_updates: true,
        design_notifications: true,
        production_notifications: true,
        delivery_notifications: true,
        payment_reminders: true,
        marketing: false
      }
    }
  },
  computed: {
    ...mapGetters({
      company: 'company/getCompanyData'
    })
  },
  methods: {
    async load() {
      if (!this.customer) {
        return
      }
      this.loading = true
      try {
        const response = await this.$api.whatsapp.preference.list({
          opt: {
            params: {
              company_id: this.company.pk,
              customer: this.customer
            }
          }
        })
        const results =
          response.data.results !== undefined
            ? response.data.results
            : response.data
        if (results.length > 0) {
          this.preference = results[0]
        }
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (!this.customer || this.saving) {
        return
      }
      this.saving = true
      const form = { ...this.preference, customer: this.customer }
      const opt = { params: { company_id: this.company.pk } }

      try {
        if (this.preference.pk) {
          const response = await this.$api.whatsapp.preference.edit({
            pk: this.preference.pk,
            form,
            opt
          })
          this.preference = response.data
        } else {
          const response = await this.$api.whatsapp.preference.create({
            form,
            opt
          })
          this.preference = response.data
        }
      } finally {
        this.saving = false
      }
    }
  },
  watch: {
    customer: {
      immediate: true,
      handler() {
        this.load()
      }
    }
  }
}
</script>
